/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalCreateActivity.vue?vue&type=template&id=04873819"
import script from "./ModalCreateActivity.ts?vue&type=script&lang=ts&external"
export * from "./ModalCreateActivity.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports